module.exports = __webpack_public_path__ + "static/img/风险级场景_角标_image@2x.a31bd0e2.png";